import { render, staticRenderFns } from "./ClassModes.vue?vue&type=template&id=5f32611b&scoped=true&lang=pug&"
import script from "./ClassModes.vue?vue&type=script&lang=ts&"
export * from "./ClassModes.vue?vue&type=script&lang=ts&"
import style0 from "./ClassModes.vue?vue&type=style&index=0&id=5f32611b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f32611b",
  null
  
)

export default component.exports